import { useMutation, useQueryClient } from 'react-query';
import {
  createCastRelationship,
  type CreateCastRelationshipBody,
  type CreateCastRelationshipResponse
} from '../../services/castRelationshipService';
import { SCENE_QUERY_KEYS } from '../queryKeys';
import { BETTIE_QUERY_KEYS } from '../../../bettie/ui/queryKeys';

export const useCreateCastRelationship = () => {
  const queryClient = useQueryClient();
  return useMutation<CreateCastRelationshipResponse, Error, CreateCastRelationshipBody>({
    mutationFn: (body) => createCastRelationship(body),
    onSuccess: () => {
      queryClient.invalidateQueries(SCENE_QUERY_KEYS.castRelationships());
      queryClient.invalidateQueries(BETTIE_QUERY_KEYS.bettieBalances);
    }
  });
};
